module.exports = __webpack_public_path__ + "static/media/logo.f7a244ea.png";